import {
  toSet1glep2u1u9tcb as toSet,
  toCollection105f1cp28k3eu as toCollection,
} from './_Arrays.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { EmptyIterator_instance9af4no2q3fjf as EmptyIterator_instance } from './CollectionsKt.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  setOf1u3mizs95ngxo as setOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from './collectionJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from './HashSet.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function emptySet() {
  return EmptySet_instance;
}
function setOf_0(elements) {
  return toSet(elements);
}
var EmptySetClass;
function EmptySet() {
  if (EmptySetClass === VOID) {
    class $ {
      constructor() {
        this.ll_1 = 3406603774387020532n;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, KtSet()) : false) {
          tmp = other.s1();
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '[]';
      }
      v2() {
        return 0;
      }
      s1() {
        return true;
      }
      ck(element) {
        return false;
      }
      y2(element) {
        if (!false)
          return false;
        var tmp;
        if (false) {
          tmp = element;
        } else {
          tmp = THROW_CCE();
        }
        return this.ck(tmp);
      }
      dk(elements) {
        return elements.s1();
      }
      v4(elements) {
        return this.dk(elements);
      }
      u1() {
        return EmptyIterator_instance;
      }
    }
    initMetadataForObject($, 'EmptySet', VOID, VOID, [KtSet()]);
    EmptySetClass = $;
  }
  return EmptySetClass;
}
var EmptySet_instance;
function EmptySet_getInstance() {
  return EmptySet_instance;
}
function optimizeReadOnlySet(_this__u8e3s4) {
  switch (_this__u8e3s4.v2()) {
    case 0:
      return emptySet();
    case 1:
      return setOf(_this__u8e3s4.u1().w1());
    default:
      return _this__u8e3s4;
  }
}
function hashSetOf(elements) {
  return toCollection(elements, HashSet().j3(mapCapacity(elements.length)));
}
//region block: init
EmptySet_instance = new (EmptySet())();
//endregion
//region block: exports
export {
  EmptySet_instance as EmptySet_instance1j0ueo1lzaow3,
  emptySet as emptySetcxexqki71qfa,
  hashSetOf as hashSetOf1p9d9akkobppk,
  optimizeReadOnlySet as optimizeReadOnlySetbkgqv9johc5,
  setOf_0 as setOf45ia9pnfhe90,
};
//endregion

//# sourceMappingURL=Sets.mjs.map
